import request from '@/utils/request'

/**
 * 记录类型 数据 与系统设置系统(repeat)
 * @param {*} data
 */
export function crmSettingRecordListAPI(data) {
  return request({
    url: 'setting/recordList',
    method: 'post',
    data: data
  })
}

// 日志记录添加
export function crmRecordSave(data) {
  return request({
    url: 'customer/saverecord',
    method: 'post',
    data: data
  })
}


// 跟进记录列表
export function crmRecordIndex(data) {
  return request({
    url: 'customer/loglist',
    method: 'post',
    data: data
  })
}

// 跟进记录删除
export function crmRecordDelete(data) {
  return request({
    url: 'customer/dellog',
    method: 'post',
    data: data
  })
}

